<div class="loading-message message-enter-animation">
    <ng-content></ng-content>
</div>
